import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IPwcPanelButtonProps } from './types';
import { BOARD_SECTION_PWC_IMPORT } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function PwcPanelButton ({
    show,
    tooltip,
    onClick
}: IPwcPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    if (!show) {
        return null;
    }
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.IMPORT_PWC}
            title={BOARD_SECTION_PWC_IMPORT}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.IMPORT_PWC);
                onClick();
            }}
        />
    );
}
